import { Deserializable } from './deserializable.model';
import { Image } from './image.model';

export enum TIPO_EMPRESAS {
  PARCEIRA = 'parceira',
  MANTENEDORA = 'mantenedora',
  GRADUADA = 'graduada',
  PRE_INCUBADA = 'pre-incubada',
  INCUBADA = 'incubada',
}

export class Empresa implements Deserializable {
  id = '';
  nome = '';
  link = '';
  ativo = false;
  imagens = new Array<Image>();

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}
